import Splide from '@splidejs/splide';

const EL = '.js-reviews';

const initSlider = () => {
  const reviewsSection = document.querySelector(EL);

  if (reviewsSection) {
    const slider = new Splide(reviewsSection, {
      pagination: false,
      arrows: false,
      gap: 150,
      updateOnMove: true,
      breakpoints: {
        1024: {},
        767: {
          gap: 30,
          fixedWidth: '290px',
        },
      },
    }).mount();

    const prevButton = document.querySelector('.js-prev');
    const nextButton = document.querySelector('.js-next');

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => slider.go('<'));
      nextButton.addEventListener('click', () => slider.go('>'));
    }

    const paginationContainer = document.querySelector('.reviews__pagination');
    const updatePagination = () => {
      const currentIndex = slider.index + 1;
      const totalSlides = slider.length;
      paginationContainer.textContent = `${currentIndex} / ${totalSlides}`;
    };

    updatePagination();

    slider.on('move', () => {
        updatePagination();
      });

      const updateArrows = () => {
            if (slider.index === 0) {
              prevButton.classList.add('disabled');
              prevButton.disabled = true;
            } else {
              prevButton.classList.remove('disabled');
              prevButton.disabled = false;
            }

            if (slider.index === slider.length - 1) {
              nextButton.classList.add('disabled');
              nextButton.disabled = true;
            } else {
              nextButton.classList.remove('disabled');
              nextButton.disabled = false;
            }
          };

          slider.on('move', () => {
            updateArrows();
          });

          updateArrows();

    }
};

document.addEventListener('DOMContentLoaded', () => {
  initSlider();
});
